export const Domain = {
  pl: 'pl',
  ro: 'ro'
};

export const country = process.env.REACT_APP_ENVIRONMENT_LANGUAGE || Domain.pl;

export const domainConfig = {
  isRo: country === Domain.ro,
  isPl: country === Domain.pl
};

export const SYSTEM_CURRENCY = domainConfig.isPl ? 'PLN' : 'RON';
